<template>
    <v-container>

        <!-- HEADER -->
        <v-row class="mt-5" align="center">
            <v-col cols="12">
                <div class="title-section">
                    <v-btn icon color="primary" class="mb-1" @click="goBack">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    Expense Details
                </div>
            </v-col>
            <v-col cols="4">
                <v-icon color="black" large>mdi-text-box-outline</v-icon>
                <b>Created Expenses</b>
            </v-col>
            <v-col cols="4">
                <v-btn v-if="isAdmin || isReportingUser" class="normal-btn" color="primary" depressed
                    @click="showCreateDialog">
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    Create Expense
                </v-btn>
            </v-col>
            <v-col cols="4">
                <kimsa-text-field placeholder="Buscar" append-icon="mdi-magnify" outlined dense solo flat
                    @change="search = $event" />
            </v-col>
        </v-row>

        <!-- TABLE -->
        <v-data-table class="mt-5" :headers="headers" :loading="loading" :items="expenseItems" :search.sync="search"
            :items-per-page="5" :footer-props="{'items-per-page-text': 'Rows per page'}">
            <template v-slot:item.actions="{ item }">
                <v-btn class="mr-1 my-1" fab outlined x-small @click.stop="editItem(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="isAdmin || isReportingUser" class="mr-1 my-1" fab outlined x-small
                    @click.stop="deleteItem(item)">
                    <v-icon color="primary">mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- COMPONENTS -->
        <create-expense-item-dialog @success="loadExpenseItems" ref="creator" />

        <kimsa-confirm title="Eliminar" content="¿Esta seguro que desea eliminar este gasto?" persistent
            @confirm="onConfirmDelete" @cancel="currentId = null" :loading="loadingDelete" no-close-on-confirm
            ref="confirm" />

    </v-container>
</template>

<script>
import Axios from "@/utils/Axios";
import KimsaConfirm from "@/components/common/KimsaConfirm";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import CreateExpenseItemDialog from '../../components/common/expenseReport/CreateExpenseItemDialog.vue';

export default {
    name: "ExpenseReportUsers",
    components: { KimsaTextField, KimsaConfirm, CreateExpenseItemDialog },
    data() {
        return {
            loading: false,
            expenseItems: [],
            search: '',
            currentId: null,
            loadingDelete: false,
            headers: [
                { text: 'Description', value: 'name', class: 'grey white--text' },
                { text: 'Date', value: 'date', class: 'grey white--text' },
                { text: '', value: 'actions', sortable: false, class: 'grey' },
            ],
        }
    },
    computed: {
        expenseReportId(vm = this) {
            return vm.$route.params.id || null
        }
    },
    async mounted() {
        const vm = this
        await vm.loadExpenseItems()
    },
    methods: {
        async loadExpenseItems() {
            const vm = this
            vm.loading = true

            await Axios.post(`expense-reports/${vm.expenseReportId}/items/list`).then(res => {
                // console.log('res loadExpenseItems', res)
                vm.expenseItems = res.data.result.expenseItems.map(expenseItem => {
                    return {
                        ...expenseItem,
                        date: vm.$moment(expenseItem.date).format('DD-MM-YYYY'),
                        created_at: vm.$moment(expenseItem.created_at).format('DD-MM-YYYY'),
                        updated_at: vm.$moment(expenseItem.updated_at).format('DD-MM-YYYY'),
                    }
                })
            }).catch(er => {
                console.log('error loadExpenseItems', er)
            }).finally(() => {
                vm.loading = false
            })
        },
        showCreateDialog() {
            const vm = this
            vm.$refs.creator.show(vm.expenseReportId, vm.expenseItems[0].report)
        },
        editItem(item) {
            const vm = this
            vm.$refs.creator.loadExpenseItem(item.id, item.report)
        },
        deleteItem(item) {
            const vm = this
            vm.$refs.confirm.show()
            vm.currentId = item.id
        },
        async onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true

            await Axios.delete(`expense-reports/items/${vm.currentId}/delete`).then(res => {
                // console.log('res onConfirmDelete',res)
                vm.toast('Gasto eliminado')
            }).catch(er => {
                console.log('er', er)
                vm.toast('error onConfirmDelete', er)
            })

            vm.loadingDelete = false
            vm.currentId = null

            vm.$refs.confirm.hide()
            await vm.loadExpenseItems()
        },
        goBack() {
            const vm = this;
            if (vm.isClient || vm.isAdmin) {
                return vm.$router.push({
                    name: 'clients.details',
                    params: { id: vm.expenseItems[0].report.client_id },
                    query: { 'tab': 'ListExpenseReports' }
                })
            } else {
                vm.$router.back()
            }
        }
    }
}
</script>

<style scoped>
.title-section {
    color: var(--v-primary-base);
}
</style>